<template>
<div>
  <v-navigation-drawer
      :value="value"
      @input="input"
      fixed
      right
      temporary
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img :src="gravatar">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{me.realName}}</v-list-item-title>
            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          @click="$router.push('/admin')"
          v-if="me.admin === true"
          :disabled="$route.path === '/admin'"
        >
          <v-list-item-icon>
            <v-icon>mdi-shield-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Admin</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/caller')">
          <v-list-item-icon>
            <v-icon>mdi-headset</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Caller</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/directory')">
          <v-list-item-icon>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-headphones</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-switch @change="toggleRecorderMode" :input-value="recorderMode" class="recorder-mode"></v-switch>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
        v-for="item in (siteSettings && siteSettings.menuItems ? siteSettings.menuItems : [])"
          :key="item.title"
          @click="openLink(item)"
          :disabled="$route.path === item.route"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
              <v-icon v-if="item.external" x-small color="grey">mdi-open-in-new</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item @click="$store.dispatch('me/logout')">
          <v-list-item-icon>
            <v-icon>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</div>
</template>
<script>
import { mapState } from 'vuex'
import { wantBind } from '@/store'
import * as url from 'url'

export default {
  data: () => ({
    hours: false,
  }),
  props: ['value'],
  computed: {
    url () {
      return url
    },
    gravatar: function () {
      return this.$store.getters['me/gravatar']()
    },
    recorderMode: function () {
      return this.$store.getters['currentHour/getRecorderMode']()
    },
    ...mapState({
      me: state => state.me,
    }),
    siteSettings: function () {
      return this.$store.getters['siteSettings/getAll']()
    },
  },
  methods: {
    input (event) {
      this.$emit('input', event)
    },
    toggleRecorderMode: function () {
      this.$store.commit('currentHour/toggleRecorderMode', !this.recorderMode)
    },
    openLink: function (item) {
      if (item.external) {
        window.open(item.route, '_blank')
      } else {
        this.$router.push(item.route)
      }
    },
  },
  mounted: function () {
    wantBind(() => { this.$store.dispatch('currentHour/bindCurrent') })
    wantBind(() => { this.$store.dispatch('siteSettings/bindSiteSettings') })
  },
}
</script>

<style scoped>
  .recorder-mode {
    margin-top: 0px;
  }
</style>
